import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import {ComposerStateService} from '@app/model-composer';
import {ComposerPanelStateService} from '@app/model-composer/services/composer-panel-state.service';
import {ComposerPanelTab} from '@app/model-composer/enums/composer-panel-tab.enum';
import {ComposerPricingService} from '@app/model-composer/services/composer-pricing.service';
import {TranslatePipe} from "@ngx-translate/core";
import {AsyncPipe, LowerCasePipe} from "@angular/common";
import {OrderService} from "@service/order/order.service";

@Component({
  selector: 'app-composer-footer',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    TranslatePipe,
    LowerCasePipe,
    AsyncPipe
  ],
  template: `
    <footer class="
    ipe:flex ipe:items-center ipe:justify-between ipe:gap-4
    ipe:px-5 ipe:py-4
    ipe:border-t ipe:border-[#ede8e3]
    ipe:bg-white
  ">
      <div class="ipe:flex ipe:flex-col ipe:gap-1">
      <span class="ipe:text-sm ipe:text-gray-400  ipe:tracking-[0.15em] font-walter">
        @if (!oldCompositionId) {
          {{ 'CONFIGURAZIONE' | translate }}
        } @else if ((configuration | async); as configuration) {
          {{ 'MODIFICA_CONFIGURAZIONE' | translate }} - {{configuration?.order?.name}}
        }
      </span>
        <div class="ipe:flex ipe:flex-wrap ipe:items-center ipe:gap-x-3 ipe:gap-y-1">
        <span class="ipe:text-sm ipe:text-gray-700">
          {{ compositionCount() }} {{ 'composition.elements' | translate | lowercase }}
        </span>
          @if (compositionCount() > 0) {
            @if (stale()) {
              <span
                class="ipe:text-sm ipe:text-[#000] ipe:cursor-pointer ipe:hover:underline ipe:transition-colors"
                (click)="requestPrice()"
              >
              {{ 'COMPUTE_AMOUNT'  | translate }}
            </span>
            } @else {
              @switch (pricing().kind) {
                @case ('loading') {
                  <span class="ipe:text-sm ipe:font-semibold ipe:text-[#000] ipe:animate-pulse">
                  {{ 'COMPUTING'  | translate }}
                </span>
                }
                @case ('ready') {
                  <div class="ipe:flex ipe:items-center ipe:gap-2">
                  <span class="ipe:text-sm ipe:font-semibold ipe:text-[#000]">
                    {{ pricing().value.amountAll }}
                  </span>
                    <span
                      class="
                      ipe:inline-flex ipe:items-center ipe:justify-center
                      ipe:w-5 ipe:h-5
                      ipe:text-gray-400
                      ipe:hover:text-gray-700
                      ipe:cursor-pointer
                      ipe:transition-colors
                    "
                      (click)="requestPrice()"
                      title="Aggiorna prezzo"
                    >
                    ↻
                  </span>
                  </div>
                }
                @case ('error') {
                  <div class="ipe:flex ipe:items-center ipe:gap-2">
                  <span class="ipe:text-sm ipe:text-red-500">
                    {{ pricing().message }}
                  </span>
                    <span
                      class="
                      ipe:inline-flex ipe:items-center ipe:justify-center
                      ipe:w-5 ipe:h-5
                      ipe:text-gray-400
                      ipe:hover:text-gray-700
                      ipe:cursor-pointer
                      ipe:transition-colors
                    "
                      (click)="requestPrice()"
                      title="Riprova"
                    >
                    ↻
                  </span>
                  </div>
                }
                @default {
                  <span
                    class="ipe:text-sm ipe:text-[#000] ipe:cursor-pointer ipe:hover:underline ipe:transition-colors"
                    (click)="requestPrice()"
                  >
                  {{ 'COMPUTE_AMOUNT' | translate }}
                </span>
                }
              }
            }
          }
        </div>
      </div>
      <button
        (click)="openSummary()"
        [disabled]="!canOpenSummary()"
        class="
        ipe:px-6 ipe:py-2
        ipe:text-sm  ipe:tracking-[0.15em]
        ipe:font-medium ipe:transition-all ipe:border
        font-walter
      "
        [class]="canOpenSummary()
        ? 'ipe:bg-[#000] ipe:text-white ipe:border-[#000] ipe:hover:bg-[#f6f3f1] ipe:hover:text-gray-800 ipe:cursor-pointer'
        : 'ipe:bg-gray-100 ipe:text-gray-400 ipe:border-gray-200 ipe:cursor-not-allowed'
      "
      >
        {{ 'GO_TO_SUMMARY' | translate }}
      </button>
    </footer>
  `
})
export class ComposerFooterComponent {
  private state = inject(ComposerStateService);
  private panelState = inject(ComposerPanelStateService);
  private pricingSvc = inject(ComposerPricingService);
  private orderService = inject(OrderService);
  readonly configuration = this.orderService.getConfiguration;
  readonly composition = this.state.composition;
  readonly oldCompositionId = this.state.oldCompositionId();
  readonly compositionCount = computed(() => this.composition().length);
  readonly pricing = this.pricingSvc.pricing;
  readonly stale = this.pricingSvc.stale;
  readonly canOpenSummary = computed(() => this.compositionCount() > 0 && this.pricingSvc.canOpenSummary());

  requestPrice() {
    this.pricingSvc.request();
  }

  openSummary() {
    if (!this.canOpenSummary()) { return; }
    this.panelState.setTab(ComposerPanelTab.Pricing);
  }
}
